import React, {useContext, useEffect, useState} from "react";
import {TranslateContext} from "../../../context/TranslateContext";
import {useHistory} from "react-router-dom";
import {MobileContext} from "../../../context/MobileContext";
import {
    deleteMacrocategoriaByIdApi,
    getMacrocategorieApi, getStrutturaMacrocategorieApi
} from "../services/MacrocategorieServices";
import ConfMacrocategorieView from "./ConfMacrocategorieView";
import AlberoStrutturaMacrocategorieController from "./AlberoStrutturaMacrocategorieController";

export default function ConfMacrocategorieController({
                                                         showModalUploadMacr,
                                                         setShowModalUploadMacr
                                                     }) {

    const [loadingData, setLoadingData] = useState(true);
    const [macrocategorie, setMacrocategorie] = useState([]);
    const [show, setShow] = useState(false);
    const [showConfirm, setShowConfirm] = useState(false);
    const [modalMsg, setModalMsg] = useState('');
    const [treeData, setTreeData] = useState([]);
    const [macrocategoriaSel, setMacrocategoriaSel] = useState();

    const {isMobile} = useContext(MobileContext);
    const {translate} = useContext(TranslateContext);

    const history = useHistory();
    const token = localStorage.getItem('ns-access-token');

    async function getMacrocategorie() {
        const response = await getMacrocategorieApi();
        setMacrocategorie(response.data.data);
        setLoadingData(false);
    }

    async function getStruttura() {
        let idSel = macrocategoriaSel ? macrocategoriaSel.id : 0;
        const response = await getStrutturaMacrocategorieApi(idSel)
        setTreeData(response.data.data?.struttura);
    }

    useEffect(() => {
        getMacrocategorie();

        if (loadingData) {
            getStruttura();
        }
    }, [macrocategoriaSel, loadingData]);

    const eliminaMacrocategoria = async () => {
        setShowConfirm(false);
        const response = await deleteMacrocategoriaByIdApi(macrocategoriaSel.id);
        if (response.data.result === -1) {
            setModalMsg(response.data.description)
            setShow(true)
        } else {
            setMacrocategorie(response.data.data);
            getStruttura();
        }
    }

    function updateDati() {
        getMacrocategorie();
        getStruttura();
    }

    function getAlberoStruttura() {
        return <AlberoStrutturaMacrocategorieController
            macrocategoriaSel={macrocategoriaSel}
            setShowConfirm={setShowConfirm}
            translate={translate}
            history={history}
            setMacrocategoriaSel={setMacrocategoriaSel}
            treeData={treeData}
        />;
    }

    return (
        <ConfMacrocategorieView
            showConfirm={showConfirm}
            show={show}
            getAlberoStruttura={getAlberoStruttura}
            loadingData={loadingData}
            setShowConfirm={setShowConfirm}
            isMobile={isMobile}
            modalMsg={modalMsg}
            setShow={setShow}
            eliminaMacrocategoria={eliminaMacrocategoria}
            translate={translate}
            macrocategorie={macrocategorie}
            macrocategoriaSel={macrocategoriaSel}
            showModalUploadMacr={showModalUploadMacr}
            setShowModalUploadMacr={setShowModalUploadMacr}
            updateDati={updateDati}
            token={token}
        />
    );
}
